export enum ConfiguracaoEscolaCodigo {
  chkGradeTemConcod = 1,
  chkGradeTemAulasSemanais = 2,
  chkGradeTemAulasAnuais = 3,
  chkTemTabelaIndicadoresFixos = 4,
  chkMostraLogoEscolaNaDeclaracao = 5,
  chkSomaCHGlobal = 6,
  chkAuxiliarAssinaHistorico = 7,
  chkImprimeResFinal = 8,
  chkImprimeProfissaoPais = 9,
  ChkOcultaRecibo = 10,
  chkLancaDiarioEletronico = 11,
  chkNaoPermitirAlunoTrocarSenha = 12,
  ddlModoLancamento = 13,
  chkLancaTotalFaltas = 14,
  chkBloqueiaPublicacaoConteudo = 15,
  chkBloqueiaSomenteNotas = 16,
  chkliberaProfAutomatico = 17,
  chkNovoConteudoLecionado = 18,
  chkLiberaVisualizacaoEtapa = 19,
  chkCargaHorariaConteudoLecionado = 20,
  chkRecursoHabilidade = 21,
  chkBloqueiaRecurso = 22,
  chkModulosRegente = 23,
  chkDistribuirNotasParaTodos = 24,
  chkNaoAbonarFaltas = 25,
  chkBloqueiaTrocaUsuario = 26,
  txtDiasLancamentoDistribuicao = 27,
  ddlEtapaBoletim = 28,
  txtNumeroVagas = 29,
  txtNomeEscolaPersonalizado = 30,
  rdbLogo = 31,
  chkBloqueiaLancamentoOcorrencias = 32,
  chkPontoExtra = 33,
  chkBloqueiaAlunoEmOutraEscola = 34,
  chkRestringeNovasTurmas = 35,
  chkBloqueiaVaga = 36,
  chkBloqueiaEdicaoHistorico = 37,
  chkEmailObrigatorio = 38,
  chkmsgDiasAula = 39,
  chkAtualizaDiasAula = 40,
  chkAtivarConfiguracoesDoCabecalho = 41,
  chkExibirNomeDaSecretariaDeEducacao = 42,
  chkModificarNomeDaEscola = 43,
  chkBloqueiaAceleracao = 44,
  chkBloqueiaReclassificacaoAnterior = 45,
  chkBloqueiaTransferencia = 46,
  chkBloqueiaAlteracaoRematricula = 47,
  txtConteudoLecionado = 48,
  txtConteudoPrevisto = 49,
  txtConteudoDiario = 50,
  txtHabilidades = 51,
  txtRecursos = 52,
  txtAtividadesProfessor = 53,
  txtPDI = 54,
  AlocacaoCompartilhada = 55,
  pdiSigla = 56,
  pdiDescricao = 57,
  NomeFichaAvaliativa = 58,
  /**
   * Janela em que o RESPONSÁVEL pode renovar a matrícula do filho pelo portal. São parâmetros de
   * DATA por escola e ano; em branco ou com data inválida a rematrícula fica FECHADA, e o card
   * não aparece na Home da família. Quem lê é o backend — ver
   * `Application/Services/Academico/JanelaRematriculaResponsavel.cs`.
   */
  DataAberturaRematriculaResponsavel = 59,
  DataFechamentoRematriculaResponsavel = 60,
  BloqueiaEdicaoAEE = 61,
}
